<template>
  <div class="config-station-container">
    <div class="station-search-area">
      <template v-if="devId == -1">
        设备：
        <Select v-model="currentStationId" number style="width: 250px; margin-right: 10px">
          <template v-for="(item, idx) in devices">
            <Option :value="item.id" :key="idx">{{item.name}}</Option>
          </template>
        </Select>
      </template>

      起始时间：
      <DatePicker v-model="filter.start" type="datetime" placeholder="请选择开始时间" style="width: 175px; margin-right: 10px;"></DatePicker>
      截止时间：
      <DatePicker v-model="filter.end" type="datetime" placeholder="请选择截止时间" style="width: 175px; margin-right: 10px;"></DatePicker>
      <Button type="info" :loading="loading" @click="getWillSieHistory" style="margin-right: 10px;">查询</Button>
    </div>
    <div class="station-data-area" ref="table">
      <u-table :data="history" use-virtual style="width: 100%;" row-key="id" border stripe :height="tabHeight" default-expand-all :page-sizes="[15, 50, 100, 200, 500]" :pagination-show="true" :total="filter.total" :page-size="filter.pageSize" :current-page="filter.pageIndex" @handlePageSize="handlePageSize">
        <u-table-column type="index" label="序号" width="50"></u-table-column>
        <u-table-column prop="TskStartTime" label="发生时间" sortable width="155">
          <template slot-scope="params">
            {{new Date(params.row.content.time).format('yyyy-MM-dd HH:mm:ss')}}
          </template>
        </u-table-column>
        <u-table-column prop="state" label="播放状态" sortable>
          <template slot-scope="params">
            {{params.row.content.playName}}
          </template>
        </u-table-column>
        <u-table-column prop="volume" label="音量" sortable>
          <template slot-scope="params">
            {{params.row.content.volume}}
          </template>
        </u-table-column>
      </u-table>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Device',
  components: {
  },
  props: {
    devId: {
      type: Number,
      default: -1
    },
    // devices: {
    //   type: Array,
    //   default(){return []},
    // },
  },
  data() {
    return {
      previewUrl: '',
      tabHeight: 300,
      loading: false,
      currentStationId: 0,
      filter: {
        total: 0,
        pageIndex: 1,
        pageSize: 15,
        start: '',
        end: '',
      },
      history: [],
      devs: [],
      count: 0,
      getAllData: [],
      getTaskData: [],
      devices: [],
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('group', ['groupPathName']),
    ...mapState('cmd', ['windowOnResize', 'cmds']),
    ...mapState('common', ['powerBoxAlarmTypes', 'productCodes', 'poleType']),
    ...mapState('group', ['selectedDevices', 'selectedNode']),
  },
  watch: {
    devId() {
      this.setTableHeight();
    },
    windowOnResize() {
      this.setTableHeight();
    },
    selectedNode() {
      this.getBroads();
      this.getWillSieHistory();
    },
    currentStationId() {
      this.getWillSieHistory();
    }
  },
  mounted: function () {
    this.getBroads();
    this.getAll()
    this.getTask()
    setTimeout(() => {
      this.setTableHeight();
      this.getWillSieHistory();
    }, 20);
    let now = new Date();
    now.setHours(23, 59, 59, 0)
    this.filter.end = now.format('yyyy-MM-dd HH:mm:ss');
    now = new Date();
    now.setMonth(now.getMonth() - 1);
    this.filter.start = now.format('yyyy-MM-dd HH:mm:ss');
  },
  methods: {
    getBroads: function () {
      let poleId = 0, groupId = 0;
      if(this.selectedNode.type != this.productCodes.station){
        groupId = this.selectedNode.id;
      }else{
        poleId = this.selectedNode.poleId;
      }
      this.$axios.post(`//${this.domains.trans}/pole/config/QueryBroadList`, {groupId, poleId}).then(res => {
        if (res.code != 0) {
          // this.$Message.error(res.data);
          return;
        }
        res.data.map(p => {
          if(!p.content){
            p.content = {};
          }
          if(!p.content.tasks){
            p.content.tasks = [];
          }
        })
        this.$set(this, 'devices', res.data);
        this.defaultDev();
      })
    },
    getAll() {
      this.$axios.post(`//${this.domains.trans}/media/operation/GetAll`, {}).then(res => {
        if (res.code != 0) {
          // this.$Message.error(res.data);
          return;
        }
        this.$set(this, 'getAllData', res.data);
      });
    },
    getTask() {
      this.$axios.get(`//${this.domains.trans}/media/task`).then(res => {
        if (res.code != 0) {
          // this.$Message.error(res.data);
          return;
        }
        this.$set(this, 'getTaskData', res.data);
      });
    },
    defaultDev() {
      if (this.devices.length > 0 && this.devId == -1) {
        this.currentStationId = this.devices[0].id;
        return
      }
      if (this.devId != -1) {
        this.currentStationId = this.devId;
      }
    },
    handlePageSize: function (params) {
      this.filter.pageSize = params.size;
      this.filter.pageIndex = params.page;
      this.getWillSieHistory();
    },
    setTableHeight: function () {
      this.tabHeight = this.$refs.table.clientHeight - 3;
    },
    getWillSieDevices: async function () {
      let res = await this.$axios.get(`//${this.domains.trans}/pole/WillSieDevice?index=0&size=10000`);
      if (res.code != 0) {
        return;
      }
      this.$set(this, 'devs', res.data);
    },
    getWillSieHistory: async function () {
      if(this.currentStationId <= 0)return;
      let params = {
        paramId: this.currentStationId,
        start: new Date(this.filter.start).format('yyyy-MM-dd HH:mm:ss'),
        end: new Date(this.filter.end).format('yyyy-MM-dd HH:mm:ss'),
        index: this.filter.pageIndex,
        size: this.filter.pageSize,
      };
      this.loading = true;
      this.$axios.post(`//${this.domains.trans}/station/param/PagedHistory`, params).then(res => {
        this.loading = false;
        if (res.code != 0) {
          // this.$Message.error(res.data);
        } else {
          res.data.list.forEach(item => {
            switch (item.content.state) {
              case 0:
                item.content.playName = "停播状态";
                break;
              case 1:
                this.getTaskData.forEach(el2 => {
                  if (el2.id == item.content.tid) {
                    item.content.playName = "自动控制播放--->任务:" + el2.name;
                  }
                  if (item.content.tid == 0) {
                    item.content.playName = "自动控制播放--->未设置";
                  }
                });
                break;
              case 2:
                this.getAllData.forEach(el => {
                  if (el.id == item.content.mid) {
                    item.content.playName = "手动控制播放--->节目:" + el.name;
                  }
                  if (item.content.mid == 0) {
                    item.content.playName = '手动控制播放--->未设置';
                  }
                });
                break;
              case 3:
                this.getAllData.forEach(el => {
                  if (el.id == item.content.mid) {
                    item.content.playName = "联动控制播放--->任务:" + el.name + "--->到期时间:" + item.content.expire;
                  }
                  if (item.content.mid == 0) {
                    item.content.playName = '联动控制播放--->未设置';
                  }
                });
                break;
            }
          });
          this.$set(this, 'history', res.data.list);
          this.filter.total = res.data.count;
        }
      });
    },
    pageSizeChange: function (size) {
      this.filter.index = 1;
      this.filter.size = size;
      this.getWillSieDevices();
    },
    pageIndexChange: function (index) {
      this.filter.index = index;
      this.getWillSieDevices();
    },
  }
}
</script>
<style scoped>
.media-player {
  /* visibility: hidden; */
  height: 0;
}
.symbol-download {
  display: flex;
  justify-content: center;
  align-items: center;
}
.symbol-download img {
  margin-right: 10px;
  cursor: pointer;
}
.config-station-container {
  /* padding: 5px;  
  padding-right: 40px; */
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: white;
  border-radius: 8px;
}
.station-search-area {
  height: 42px;
  width: 100%;
  flex: none;
  /* border: solid 1px #DCDEE2; */
  border-radius: 6px;
  margin-bottom: 5px;
  padding: 0 3px;
  display: flex;
  align-items: center;
}
.station-data-area {
  /* border: solid 1px red; */
  width: 100%;
  height: 100%;
  flex: auto;
  /* border: solid 1px #DCDEE2; */
  border-radius: 6px;
}
</style>
